import { z } from 'zod';

const envSchema = z.object({
    VITE_API_ROOT: z.url('VITE_API_ROOT must be a valid URL'),
    MODE: z.enum(['development', 'production', 'test']).default('development'),
});

type Env = z.infer<typeof envSchema>;

let env: Env;

try {
    env = envSchema.parse({
        VITE_API_ROOT: import.meta.env.VITE_API_ROOT,
        MODE: import.meta.env.MODE,
    });
} catch (error) {
    if (error instanceof z.ZodError) {
        const errorMessages = error.issues.map((e) => `${e.path.join('.')}: ${e.message}`).join('\n');
        throw new Error(`❌ Invalid environment variables:\n${errorMessages}\n\nPlease check your .env file.`);
    }
    throw error;
}

export { env };
